import tw from "tailwind-styled-components";
export const DropdownItem = tw.div`
  flex
  flex-col
  items-stretch
  py-2
  px-4
  text-sm
  cursor-pointer
  hover:bg-grayscale-lighter

  ${({ $size })=>$size === "sm" ? "text-sm font-light" : "text-md"}
`;
export default DropdownItem;
